export default {
  bad_connection: 'อ๊ะ มีบางอย่างผิดปกติ โปรดตรวจสอบการเชื่อมต่อเครือข่ายของคุณแล้วลองอีกครั้ง',
  send: 'ส่ง',
  select_hotel: 'กรุณาเลือกโรงแรมที่คุณเข้าพัก',
  select_language: 'โปรดเลือกภาษาของคุณ',
  start_chatting: 'เริ่มแชท',
  languages: 'ภาษา',
  menu: 'เมนู',
  close: 'ปิด',
  back: 'กลับ',
  next: 'ต่อไป',
  message: 'กรุณาถามคำถาม',
  search: 'ค้นหา',
  select: 'เลือก',
  sign_in: 'เข้าสู่ระบบ',
  sign_out: 'ออกจากระบบ',
  sign_up: 'ลงชื่อ',
  smoking: 'สูบบุหรี่',
  no_smoking: 'ไม่สูบบุหรี่',
  adults: 'ผู้ใหญ่',
  xAdults: 'ผู้ใหญ่',
  children: 'เด็ก',
  ageOfChild: 'อายุของเด็ก',
  seeAll: 'ดูทั้งหมด',
  email: 'อีเมล',
  email_confirmation: 'อีเมล์ (เพื่อยืนยัน)',
  phone_number: 'หมายเลขโทรศัพท์',
  icc: 'ไอซีซี',
  month: 'เดือน',
  year: 'ปี',
  including_taxes: 'รวมภาษีแล้ว',
  excluding_taxes: 'ไม่รวมภาษี',
  show_more: 'แสดงมากขึ้น',
  show_less: 'แสดงน้อยลง',
  file_upload: {
    unsupported_file_type: 'ขออภัย เราไม่รองรับไฟล์ประเภท {file_type}',
    file_size_exceeded: 'ไฟล์มีขนาดเกินขีดจำกัด 10mb',
    file_upload_failed: 'การอัปโหลดไฟล์ล้มเหลว',
    max_files_upload_simultaneously: 'สามารถอัพโหลดได้สูงสุด 5 ไฟล์พร้อมกัน'
  },
  base: {
    back_to_list: 'กลับไปที่รายการ',
    pay: 'จ่าย',
    cancel: 'ยกเลิก',
    delete: 'ลบ',
    yes: 'ใช่',
    no: 'เลขที่',
    book: 'หนังสือ',
    direct_price: 'ราคาตรง',
    membership_rate: 'อัตราสมาชิก',
    regular_rate: 'อัตราปกติ',
    expand_for_price: 'ขยายเพื่อเปรียบเทียบ',
    confirmSelection: 'ยืนยันการเลือก',
    neverAskAgain: 'อย่าถามอีก',
    accept: 'ยอมรับ',
    do_not_accept: 'ไม่ยอมรับ',
    password: 'รหัสผ่าน',
    email: 'อีเมล',
    save: 'บันทึก',
    confirm_password: 'ยืนยันรหัสผ่าน',
    error02: 'เกิดข้อผิดพลาดระหว่างการประมวลผล. กรุณาลองใหม่อีกครั้งในภายหลัง.',
    errorCode: {
      3001: 'เกิดข้อผิดพลาดการหมดเวลา การชำระเงินยังไม่ได้รับการประมวลผล',
      3002: 'กระบวนการชำระเงินล้มเหลว',
      3003: 'การ์ดใบนี้ไม่สามารถใช้ได้',
      3004: 'กรุณายืนยันหมายเลขบัตร',
      3005: 'โปรดตรวจสอบให้แน่ใจว่าวันหมดอายุของคุณถูกต้อง',
      3006: 'การรับรองความถูกต้อง 3D Secure ล้มเหลว',
      3007: 'ไม่รับบัตรเครดิตหรือหมายเลขบัตรไม่ถูกต้อง',
      3008: 'การรับรองความถูกต้อง 3D Secure ถูกยกเลิก',
      3009: 'การรับรองความถูกต้อง 3D Secure ถูกระงับเนื่องจากมีคำขอหลายรายการ',
      3011: 'เกิดข้อผิดพลาดการหมดเวลา การชำระเงินยังไม่ได้รับการประมวลผล',
      3203: 'เกิดข้อผิดพลาดระหว่างการประมวลผล. กรุณาลองใหม่อีกครั้งในภายหลัง.',
      3204: 'กระบวนการชำระเงินล้มเหลว โปรดใช้บัตรอื่นหรือลองอีกครั้งในภายหลัง',
      3205: 'การ์ดใบนี้ไม่สามารถใช้ได้'
    }
  },
  triplaPayIssues: {
    INVALID_PARAMETER_SYNTAX: 'กรุณาตรวจสอบข้อมูลที่คุณกรอก.',
    INVALID_EXPIRATION_YEAR: 'โปรดตรวจสอบให้แน่ใจว่าวันหมดอายุของคุณถูกต้อง',
    Invalid_card_number: 'กรุณายืนยันหมายเลขบัตร',
    Others: 'กรุณาตรวจสอบข้อมูลที่คุณกรอก.'
  },
  validation: {
    is_required: 'จำเป็นต้องระบุ {field}',
    correct_email: 'กรุณากรอกที่อยู่อีเมลที่ถูกต้อง',
    invalid_integer: 'กรุณากรอกจำนวนเต็ม'
  },
  chat_body: {
    deleted_message: 'คุณลบข้อความนี้แล้ว',
    op_deleted_msg: 'โอเปอเรเตอร์ลบข้อความนี้',
    delete_message: 'ลบข้อความ',
    delete_message_desc: 'คุณแน่ใจหรือไม่ว่าต้องการลบข้อความนี้ สิ่งนี้ไม่สามารถยกเลิกได้'
  },
  user_top: {
    information:
      'หากคุณต้องการสนทนากับเราต่อบนอุปกรณ์อื่น โปรดลงทะเบียน คุณสามารถดึงข้อความถึงคุณบนอุปกรณ์ใดก็ได้เมื่อคุณลงชื่อเข้าใช้',
    terms_and_condition: {
      before: 'ในการสมัคร ฉันยอมรับ',
      link: 'ข้อกำหนดและเงื่อนไข',
      and: 'และ',
      privacy_policy: 'นโยบายความเป็นส่วนตัว',
      after: '-'
    },
    sign_in_with_facebook: 'เข้าสู่ระบบด้วย Facebook',
    sign_out_with_facebook: 'ออกจากระบบ Facebook บนอุปกรณ์นี้',
    sign_in_with_line: 'เข้าสู่ระบบด้วย LINE',
    sign_in_with_weibo: 'ลงชื่อเข้าใช้ด้วย Weibo',
    create_account: 'สร้างบัญชี',
    or: 'หรือ',
    already_have_an_account: 'มีบัญชีอยู่แล้ว?',
    sign_in_with_email: 'เข้าสู่ระบบด้วยอีเมล',
    forgot_password: 'ลืมรหัสผ่าน?'
  },
  new_user: {
    information: 'กรุณากรอกชื่อและที่อยู่อีเมลของคุณแล้วกดลงทะเบียน',
    information2: 'คุณจะได้รับการยืนยันจาก chatbot@tripla.jp',
    first_name: 'ชื่อจริง',
    last_name: 'นามสกุล',
    name_placeholder: 'ชื่อของคุณ',
    email_placeholder: 'ที่อยู่อีเมล',
    submit: 'ลงชื่อ',
    email_sent:
      'ลิงก์ยืนยันได้ถูกส่งไปยังที่อยู่อีเมลของคุณแล้ว โปรดคลิกลิงก์ที่เพิ่งส่งไปและ {sign in}',
    error_message: {
      problem: 'เกิดปัญหาในการสร้างบัญชีของคุณ โปรดตรวจสอบที่อยู่อีเมลของคุณแล้วลองอีกครั้ง',
      email: 'อีเมลไม่ถูกต้องหรือถูกใช้ไปแล้ว'
    }
  },
  new_session: {
    information: 'กรุณากรอกที่อยู่อีเมลและรหัสผ่านของคุณแล้วกดลงชื่อเข้าใช้',
    email_placeholder: 'ที่อยู่อีเมล',
    password_placeholder: 'รหัสผ่าน',
    submit: 'เข้าสู่ระบบ/สมัครสมาชิก',
    error_message: {
      email: 'ขออภัย อีเมลหรือรหัสผ่านของคุณอาจไม่ถูกต้อง',
      known_user_different: 'ผู้ใช้ที่รู้จักนั้นแตกต่างออกไป'
    }
  },
  destroy_session: {
    information:
      'คุณต้องการออกจากระบบหรือไม่? คุณต้องลงชื่อเข้าใช้ใหม่หากต้องการแสดงข้อความที่มีอยู่',
    submit: 'ออกจากระบบ'
  },
  forgotten_password: {
    information: 'กรุณากรอกอีเมลของคุณ. เราจะส่งการยืนยันไปยังบัญชีอีเมลของคุณ',
    email_placeholder: 'ที่อยู่อีเมล',
    submit: 'ส่ง',
    error: 'ไม่สามารถรีเซ็ตรหัสผ่านได้'
  },
  forgotten_password_confirmation: {
    information: 'คุณจะได้รับอีเมลพร้อมคำแนะนำในการรีเซ็ตรหัสผ่านภายในไม่กี่นาที'
  },
  reset_password: {
    title: 'เปลี่ยนรหัสผ่าน',
    password_title: 'รหัสผ่าน',
    password_hint: 'อย่างน้อย 8 ตัวอักษร',
    password_confirmation_title: 'ยืนยันรหัสผ่าน)',
    submit: 'เปลี่ยนรหัสผ่าน'
  },
  set_reset_password: {
    title: 'เปลี่ยนรหัสผ่าน',
    information: 'รหัสผ่านของคุณถูกรีเซ็ตแล้ว',
    information2: 'โปรดกลับไปยังจุดที่คุณรีเซ็ตรหัสผ่านและลงชื่อเข้าใช้อีกครั้ง'
  },
  menu_items: {
    1: 'เช็คห้องว่าง',
    2: 'จองห้องพัก',
    3: 'ยืนยันการจองห้องพัก'
  },
  modal: {
    back_to_chat: 'กลับไปแชท'
  },
  gmoPaypalOptions: {
    visa: 'วีซ่า',
    master: 'มาสเตอร์การ์ด',
    mastercard: 'มาสเตอร์การ์ด',
    amex: 'อเมริกันเอ็กซ์เพรส',
    jcb: 'เจซีบี',
    diners: 'ไดเนอร์สคลับ'
  },
  credit_card: {
    error: {
      cvv: 'โปรดตรวจสอบให้แน่ใจว่า CVV ของคุณถูกต้อง',
      expiration: 'โปรดตรวจสอบให้แน่ใจว่าวันหมดอายุของคุณถูกต้อง',
      name: 'โปรดตรวจสอบให้แน่ใจว่าชื่อผู้ถือบัตรถูกต้อง',
      number: 'กรุณาใช้หมายเลขบัตรเครดิตที่ถูกต้อง',
      unknown:
        'เกิดปัญหาในการดำเนินการตามคำขอของคุณ โปรดตรวจสอบให้แน่ใจว่าข้อมูลที่คุณให้มานั้นถูกต้อง',
      reservation_month:
        'โปรดตรวจสอบให้แน่ใจว่าวันหมดอายุของบัตรเครดิตควรมีเวลาเหลืออย่างน้อยหนึ่งเดือนหลังจากวันที่จอง'
    },
    accept: 'พวกเรายอมรับ:',
    cvv: 'ซีวีวี',
    expiration: 'วันหมดอายุ',
    intro: 'กรุณาป้อนข้อมูลที่จำเป็นสำหรับบัตรที่คุณต้องการใช้',
    name: 'ชื่อผู้ถือบัตร',
    number: 'หมายเลขบัตร',
    save: 'บันทึกการ์ดใบนี้',
    submit: 'เพิ่มการ์ด',
    title: 'เพิ่มบัตรเครดิตใหม่',
    security_code: 'รหัสรักษาความปลอดภัย',
    card_holder_confirm: 'กรุณายืนยันชื่อผู้ถือบัตร',
    card_holder_format_confirm: 'กรุณากรอกชื่อของคุณด้วยตัวอักษรโรมันแบบครึ่งความกว้าง',
    expiration_confirm: 'กรุณายืนยันวันหมดอายุ',
    card_cvv_confirm: 'กรุณายืนยันรหัสความปลอดภัย',
    card_number_confirm: 'กรุณายืนยันหมายเลขบัตร',
    card_brand: 'ประเภทบัตร',
    select_card_brand: 'เลือกประเภทบัตร'
  },
  payment: {
    total: 'ทั้งหมด'
  },
  currencies: {
    JPY: 'เยนญี่ปุ่น'
  },
  chat_channels: {
    title: 'กรุณาเลือกช่อง',
    facebook: 'ผู้สื่อสาร',
    web: 'เว็บ',
    line: 'เส้น',
    whats_app: 'WhatsApp'
  },
  rev_requests: {
    title: 'คำขอ',
    request: 'ขอ',
    status: 'สถานะ',
    no_data: 'ขณะนี้คุณไม่มีคำขอ',
    payment: 'การชำระเงิน',
    customer: 'ลูกค้า',
    phone: 'โทรศัพท์',
    people: 'ประชากร',
    facility_name: 'ชื่อสถานที่',
    requested_day: 'วันที่ขอ',
    requested_time: 'เวลาที่ขอ',
    confirm_cancel_msg:
      'โปรดยืนยันว่าคุณต้องการยกเลิกคำขอนี้ เราจะส่งการแจ้งเตือนไปยังผู้จัดการและเมื่อการยกเลิกเสร็จสมบูรณ์ คุณจะได้รับการยืนยัน',
    cancel_request: 'ยกเลิกคำขอ',
    edit_request: 'แก้ไขคำขอ',
    keep_request: 'เอาไว้ขอ'
  },
  requests: {
    statuses: {
      _destroyed: 'ถูกทำลาย',
      cancel_requested: 'ยกเลิกคำขอ',
      cancelled: 'ยกเลิก',
      change_requested: 'ร้องขอการอัปเดตแล้ว',
      created: 'สร้าง',
      departure_unconfirmed: 'ออกเดินทางไม่ได้รับการยืนยัน',
      done: 'เสร็จแล้ว',
      in_progress: 'กำลังดำเนินการ',
      no_show: 'ไม่แสดง',
      stopped: 'หยุดแล้ว',
      wait_listed: 'รอเข้ารายการ.',
      waiting_detail: 'รายละเอียดรอครับ'
    }
  },
  best_rate: 'อัตราที่ดีที่สุด',
  time_picker: {
    AM: 'เช้า',
    PM: 'น'
  },
  details_page: {
    details: 'รายละเอียดเพิ่มเติม'
  },
  date_range: {
    select: 'เลือกวันที่จะเข้าพัก',
    send: 'คลิกเลือกเพื่อดำเนินการต่อ',
    no_disabled_dates: 'คุณไม่สามารถรวมวันที่ไม่ว่างได้ โปรดเลือกช่วงวันที่ที่ถูกต้อง'
  },
  facebook: {
    email_sent:
      'ลิงก์ยืนยันได้ถูกส่งไปยังที่อยู่อีเมลของคุณแล้ว กรุณาคลิกที่ลิงค์เพื่อยืนยันและดำเนินการต่อ',
    no_email: 'กรุณาระบุที่อยู่อีเมลของคุณ เราจะส่งการยืนยันการจองให้คุณหลังจากทำการจองแล้ว',
    signInFailed: 'การเข้าสู่ระบบล้มเหลว โปรดลองอีกครั้ง',
    sign_out: 'กรุณาคลิกที่ปุ่มด้านล่างเพื่อออกจากระบบ Facebook'
  },
  confirm_form: {
    search: 'ค้นหาอีกครั้ง',
    update_contact: 'อัปเดตข้อมูลการติดต่อ'
  },
  contact_form: {
    update: 'อัปเดต',
    submit: 'ส่ง',
    full_name: 'ชื่อเต็ม',
    family_name: 'นามสกุล',
    first_name: 'ชื่อจริง',
    cc_email: 'cc ส่งอีเมลไปที่ ...',
    error: {
      full_name_error: 'กรุณาระบุชื่อเต็มเป็นภาษาอังกฤษ',
      tel_format_error: 'ตัวเลข ช่องว่าง + และ () สามารถใช้เป็นหมายเลขโทรศัพท์ได้',
      tel_length_error: 'กรุณากรอกหมายเลขโทรศัพท์ที่มีมากกว่า 9 หลัก',
      email_format_error: 'โปรดระบุที่อยู่อีเมลที่ถูกต้อง (เช่น name@gmail.com)',
      email_confirmation_error: 'ที่อยู่อีเมลไม่เหมือนกัน'
    }
  },
  room_not_available: 'ขออภัย เราไม่มีห้องว่างในวันที่ที่คุณเลือก',
  search_again: 'ค้นหาอีกครั้ง',
  room_not_available_short: 'ไม่สามารถใช้ได้',
  email_form: {
    note_placeholder: 'กรุณากรอกรายละเอียดเกี่ยวกับคำขอของคุณ'
  },
  rental_car_form: {
    pickup_title: 'ร้านรับของ',
    pickup_area: 'การเลือกพื้นที่',
    pickup_shop: 'การเลือกร้านค้า',
    pickup_date_time: 'วันที่รับรถ',
    return_title: 'ร้านกลับ',
    return_area: 'การเลือกพื้นที่',
    return_shop: 'การเลือกร้านค้า',
    return_date_time: 'วันที่เดินทางกลับ',
    back: 'กลับ'
  },
  search_area_form: {
    select_prefecture_area: 'กรุณาเลือกจังหวัดและพื้นที่',
    prefecture: 'จังหวัด',
    area: 'พื้นที่'
  },
  restaurant_form: {
    breakfast: 'อาหารเช้า',
    lunch: 'อาหารกลางวัน',
    dinner: 'อาหารเย็น',
    main_time: 'เวลาหลัก',
    alternative_times: 'เวลาทางเลือก',
    pick_multiple: 'กรุณาเลือกหลายรายการ เราขอแนะนำ 3',
    any_available_time: 'เวลาใดก็ได้'
  },
  terms_of_use: 'ข้อกำหนดการใช้งาน',
  privacy_policy: 'นโยบายความเป็นส่วนตัว',
  browser_warning:
    'เว็บเบราว์เซอร์ของคุณล้าสมัย โปรดอัปเดตเพื่อความปลอดภัย ความเร็ว และประสบการณ์ที่ดีขึ้นบนเว็บไซต์นี้',
  for_night: 'สำหรับ {n} คืน | สำหรับ {n} คืน | เป็นเวลา {n} คืน',
  chat_icon: {
    chat: 'แชท'
  },
  chat_evaluation: {
    title: 'ความพึงพอใจของลูกค้า',
    msg: 'โปรดสละเวลาสักครู่เพื่อแจ้งให้เราทราบว่าคุณพอใจกับแชทบอทของเราหรือไม่',
    not_satisfied: 'ไม่พอใจ',
    satisfied: 'พอใจ'
  },
  cookie_consent: {
    title: 'จัดการการยินยอมคุกกี้',
    necessary: 'จำเป็น: ประวัติการแชทและสถานะการเข้าสู่ระบบ',
    functional:
      'ใช้งานได้: คุกกี้เหล่านี้จะบันทึกการตั้งค่าของคุณ เช่น นโยบายความเป็นส่วนตัว และเค้าโครงแชทบอท',
    performance:
      'ประสิทธิภาพ: คุกกี้เหล่านี้ช่วยให้เรานับการเข้าชมและการคลิกของผู้ใช้เพื่อช่วยเราปรับปรุงบริการของเรา',
    advertising:
      'การกำหนดเป้าหมายและการโฆษณา: คุกกี้เหล่านี้ทำให้ข้อความโฆษณาเกี่ยวข้องกับคุณมากขึ้น',
    accept_all: 'ยอมรับทั้งหมด',
    confirm: 'ยืนยันตัวเลือกของฉัน',
    cookies_accepted: 'ยอมรับคุกกี้แล้ว'
  },
  ota_name: {
    agoda: 'Agoda',
    booking_com: 'Booking com',
    expedia: 'Expedia',
    jalan: 'Jalan',
    rakuten_travel: 'Rakuten Travel',
    rakutenTravel: 'Rakuten Travel'
  }
}
